// Döviz İşlemleri sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.currency';

export const currencyGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Döviz İşlemleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Şirketinizde hangi para birimlerinin kullanılacağını seçer, güncel TCMB kurlarını görür ve tutar çevirirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve Yenile'),
    stats: t(`${G}.regions.stats`, 'Para Birimi Ayarları'),
    filters: t(`${G}.regions.filters`, 'Döviz Çevirici'),
    table: t(`${G}.regions.table`, 'TCMB kurları'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Kullanacağınız para birimlerini seçin'),
      text: t(`${G}.s1.text`, 'Para Birimi Ayarları bölümünde her para biriminin anahtarını açın veya kapatın, sonra "Kaydet"e basın. Kaydetmeden yapılan değişiklikler saklanmaz. TRY her zaman aktiftir ve kapatılamaz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Aktif para birimleri; cari, tahsilat / ödeme, kasa, banka hesabı, kredi kartı ve stok kartlarındaki para birimi seçimlerinde çıkar.'),
        t(`${G}.s1.tip2`, 'Pasif para birimi bu seçimlerde görünmez.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Tutar çevirin'),
      text: t(`${G}.s2.text`, 'Miktarı yazın, Kaynak ve Hedef para birimini seçin (yalnız aktif olanlar listelenir), Alış Kuru veya Satış Kuru seçip "Dönüştür"e basın. Ortadaki ⇄ düğmesi kaynak ile hedefi yer değiştirir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Miktarı yalnız rakamla yazın; kuruş için nokta kullanın (ör. 1250.50).'),
        t(`${G}.s2.tip2`, 'İki döviz arasında çeviri önce TL\'ye, sonra hedef dövize yapılır.'),
        t(`${G}.s2.tip3`, 'Çevirici yalnız hesaplama yapar; hiçbir kayıt veya bakiye değişmez.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Güncel kurları okuyun'),
      text: t(`${G}.s3.text`, 'TCMB Güncel Döviz Kurları tablosu Türkiye Cumhuriyet Merkez Bankası\'nın yayımladığı kurları gösterir: Alış ve Satış, efektif (banknot) alış ve satış değerleridir. Birim sütunu kurun kaç birim döviz için verildiğini gösterir. Kurlar bu ekranda elle değiştirilemez.'),
    },
    {
      region: 'header',
      title: t(`${G}.s4.title`, '4. Kurları yenileyin'),
      text: t(`${G}.s4.text`, 'Kurlar sayfa açılınca TCMB\'den çekilir; "Son güncelleme" saati tablonun sağ üstünde yazar. Güncel değerleri almak için "Yenile"ye basın. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
